import BaseUtils from './base'
import i18n from './i18n'

function format(code, args, count) {
  const udf = typeof count === 'undefined'

  if (udf) {
    return i18n.t(code, args)
  } else {
    return i18n.tc(code, count, args)
  }
}

class Message {
  constructor(code, args, count) {
    this.icon = args ? args.icon : null
    this.text = format(code, args, count)
    this.action = args ? args.action : null
    this.duration = args ? args.duration : null
  }

  option(icon) {
    const opt = {
      icon: this.icon || icon,
      action: this.action,
    }
    if (this.duration) {
      opt.duration = this.duration === -1 ? null : this.duration
    }
    return opt
  }
}

class Toasted extends BaseUtils {
  clear() {
    const toasted = this.vue().$toasted
    toasted.clear()
  }

  info(code, args, count) {
    const message = new Message(code, args, count)
    const toasted = this.vue().$toasted
    toasted.clear()

    const option = message.option('info')
    option.position = 'bottom-right'
    toasted.info(message.text, option)
  }

  success(code, args, count) {
    const message = new Message(code, args, count)
    const toasted = this.vue().$toasted
    toasted.clear()

    const option = message.option('done')
    option.position = 'bottom-right'
    toasted.success(message.text, option)
  }

  error(code, args, count) {
    const message = new Message(code, args, count)
    const toasted = this.vue().$toasted
    toasted.clear()

    const option = message.option('warning')
    toasted.error(message.text, option)
  }
}

export default new Toasted()
